import React, {Component} from 'react';
import Header from "../Header/Header";
import { Player } from '@lottiefiles/react-lottie-player';
import {Redirect} from "react-router";
import {getLocationId} from "../../themes";

var animationData = require('./Thank_You_Animation.json');

class Thankyou extends Component {

    constructor(props){
        super(props);

        this.state = {
            redirect : false
        };

        setTimeout( () => {this.setState({redirect : true})}, 5000);
    }

    render() {
        if (this.state.redirect) {
            return (<Redirect refresh={true} to='/' />);
        }

        const isMucOp = getLocationId() === "MUC_OP";

        return (
            <div className="page-thankyou">
                <div className="page-inner-wrapper">
                    <Header
                        headerTitle={isMucOp ? '' : 'pageTitles.thankyouPage'}
                        deactivateLanguageSwitcher={true}
                    />
                    <div className={'content-wrapper'} onClick={()=>{this.setState({redirect : true})}}>
                        {isMucOp ? (
                            <h1 className="thankyou-text">THANK YOU!</h1>
                        ) : (
                            <Player
                                autoplay
                                loop
                                src={animationData}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Thankyou;
